// theme-sources/js/theme/components/product-media-gallery.js
import Swiper from "swiper";
import { Thumbs, Keyboard, Mousewheel, FreeMode } from "swiper/modules";

const DEBUG = true;

const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[MediaGallery] ${message}`, payload ?? "");
  },
};

class ProductMediaGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.init();
  }

  init() {
    const thumbsEl = this.querySelector("#thumbsSlider");
    const productEl = this.querySelector("#productSlider");

    if (!productEl) return;

    let thumbsSwiper = null;

    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        modules: [FreeMode, Keyboard, Mousewheel],
        //direction: "vertical",
        slidesPerView: 6,
        spaceBetween: 11,
        freeMode: true,
        threshold: 10,
        autoHeight: true,
        mousewheel: true,
        keyboard: true,
        watchSlidesProgress: true,
      });
    }

    const productSwiper = new Swiper(productEl, {
      modules: thumbsSwiper ? [Thumbs] : [],
      loop: true,
      initialSlide: 0,
      watchOverflow: true,
      touchStartPreventDefault: false,
      resistanceRatio: 0.85,

      grabCursor: true,
      threshold: 10,
      speed: 600,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      breakpoints: {
        0: { slidesPerView: 1.6, spaceBetween: 10, centeredSlides: true },
        600: { slidesPerView: 1.8, spaceBetween: 10, centeredSlides: true },
        768: { slidesPerView: 2.2, spaceBetween: 10, centeredSlides: true },
        1024: { slidesPerView: 1, spaceBetween: 0, centeredSlides: false },
      },
      on: {
        init: (swiper) => {
          this.bindMediaInteractions(swiper);
          this.bindVideoInteractions(swiper.el);
        },
      },
    });

    this.productSwiper = productSwiper;
    this.thumbsSwiper = thumbsSwiper;
  }

  goToVariantSlide() {
    if (!this.productSwiper) return;

    requestAnimationFrame(() => {
      this.productSwiper.slideToLoop(0, 300, false);
    });
  }

  bindMediaInteractions(productSwiper) {
    productSwiper.off("click");

    productSwiper.on("click", (swiper) => {
      const index = swiper.clickedIndex;
      if (index == null) return;

      const slide = swiper.slides[index];
      if (!slide) return;

      if (slide.dataset.type === "image") {
        const img =
          slide.querySelector(".product__media-item--variant.is-active") ||
          slide.querySelector("img");
        openMediaZoom(img);
      }
    });
  }

  bindVideoInteractions(root) {
    root
      .querySelectorAll('.swiper-slide[data-type="video"]')
      .forEach((slide) => {
        const video = slide.querySelector("video");
        const overlay = slide.querySelector(".video-play__wrapper");
        if (!video || !overlay) return;
        if (slide.__videoBound) return;
        slide.__videoBound = true;
        const showOverlay = () => {
          overlay.classList.remove("opacity-0", "pointer-events-none");
        };
        const hideOverlay = () => {
          overlay.classList.add("opacity-0", "pointer-events-none");
        };
        // ▶️ / ⏸ UNIQUEMENT via le bouton play
        overlay.addEventListener("click", (e) => {
          e.stopPropagation();
          video.paused ? video.play() : video.pause();
        });
        // vérité navigateur
        video.addEventListener("play", hideOverlay);
        video.addEventListener("pause", showOverlay);
        video.addEventListener("ended", () => {
          showOverlay();
          video.currentTime = 0;
        });
        // état initial
        video.paused ? showOverlay() : hideOverlay();
      });
  }
}
if (!customElements.get("product-media-gallery")) {
  customElements.define("product-media-gallery", ProductMediaGallery);
}

function openMediaZoom(img) {
  if (!img) return;

  const zoomContainer = document.querySelector("#zoomContainer");
  const mediaSlot = zoomContainer?.querySelector(".zoom-media");
  if (!zoomContainer || !mediaSlot) return;

  const clone = img.cloneNode(true);
  clone.classList.add("max-w-full", "max-h-full");

  mediaSlot.innerHTML = "";
  mediaSlot.appendChild(clone);

  zoomContainer.classList.remove("hidden");
  // forcer le repaint pour l'animation
  requestAnimationFrame(() => {
    zoomContainer.classList.remove("opacity-0");
  });
  document.body.classList.add("overflow-hidden");
}

function closeMediaZoom() {
  const zoomContainer = document.querySelector("#zoomContainer");
  const mediaSlot = zoomContainer?.querySelector(".zoom-media");
  if (!zoomContainer || !mediaSlot) return;

  zoomContainer.classList.add("opacity-0");

  zoomContainer.addEventListener(
    "transitionend",
    () => {
      mediaSlot.innerHTML = "";
      zoomContainer.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    },
    { once: true },
  );
}

// 🔑 BINDINGS GLOBAUX DU ZOOM (UNE FOIS)
const zoomContainer = document.querySelector("#zoomContainer");
if (zoomContainer) {
  // clic sur la croix
  zoomContainer
    .querySelector(".js-close-zoom")
    ?.addEventListener("click", closeMediaZoom);

  // clic sur l’overlay (mais PAS sur l’image)
  zoomContainer.addEventListener("click", (e) => {
    if (!e.target.closest("img")) {
      closeMediaZoom();
    }
  });
}
